const darkTheme = {
  colors: {
    primary: '#a77f62',
    primaryTransparent: 'rgba(167, 127, 98, 0.2)',
    danger: '#DF3030',
    dangerTransparent: 'rgba(223, 48, 48, 0.1)',
    success: '#3CA422',
    successTransparent: 'rgba(60, 164, 34, 0.1)',
    warning: '#FFA800',
    warningTransparent: 'rgba(255, 168, 0, 0.1)',
    info: '#5ca8ff',
    infoTransparent: 'rgba(92, 168, 255, 0.1)',

    blackTransparent: 'rgba(255, 255, 255, 0.5)',

    white: '#222222',
    whiteDark: '#000000',
    whiteDarker: '#222222',

    grayE: '#111111',
    grayD: '#444444',
    grayC: '#777777',
    gray9: '#999999',

    black2: '#dddddd',
    black3: '#eeeeee',
    black5: '#eeeeee',
    black7: '#eeeeee',
  },
};

export default darkTheme;
